module.exports = __webpack_public_path__ + "static/solidarity-labs-4-8515296d512adf8508e5340778e4ab4c.jpg";